import { AuthenticationContext } from 'react-adal';

export const adalConfig = {  
  tenant: '6eeb49aa-436d-43e6-becd-bbdf79e5077d',
  clientId: 'c862dac4-34ee-4a8d-82a6-a8f9bc47bc12',
  endpoints: {
    api:'https://login.microsoftonline.com/'
  },
  cacheLocation: 'localStorage'
};

export const authContext = new AuthenticationContext(adalConfig);

export const getToken = () => {
    let auth_token = authContext;
    
    authContext.acquireToken(adalConfig.endpoints.api, (message, token, msg) => {
       auth_token = 'ingresa'
        if (token) {
            auth_token = 'var'
        }
    });
    
   
    
    return (auth_token);

}
